import React, { useState, useEffect } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import logo from "images/logoAbbott.png";

function LoginVerificationWithInvalidEmail() {
  const { token } = useParams();
  const [userData, setUserData] = useState({ username: "", email: "" });

  useEffect(() => {
    if (token) {
      try {
        const payloadBase64 = token.split(".")[1];
        const decodedPayload = JSON.parse(atob(payloadBase64));
        setUserData({
          username: decodedPayload.username || "",
          email: decodedPayload.email || "",
        });
      } catch {
        setUserData({ username: "", email: "" });
      }
    }
  }, [token]);

  return (
    <Grid
      container
      style={{ minHeight: "100vh", flexDirection: "column", flexWrap: "nowrap", backgroundColor: "#F6F7FF" }}
    >
      <header
        style={{ width: "100%", height: "96px", minHeight: "96px", display: "flex", alignItems: "center", padding: "8px 32px", backgroundColor: "#c3c3e3", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)", boxSizing: "border-box" }}
      >
        <img src={logo} alt="Abbott" style={{ height: "80px", width: "auto", objectFit: "contain" }} />
      </header>

      <Grid item xs={12} style={{ width: "100%", flexGrow: 1, display: "flex", justifyContent: "center", alignItems: "center", padding: "32px 16px", boxSizing: "border-box" }}>
        <Paper elevation={3} style={{ width: "100%", maxWidth: "596px", padding: "40px 32px", textAlign: "center", borderRadius: "8px", boxSizing: "border-box" }}>
          
          <Typography variant="h4" style={{ fontSize: "34px", fontWeight: 400, marginBottom: "20px" }}>
            Verifique su acceso
          </Typography>

          <Typography style={{ fontSize: "20px", lineHeight: 1.6 }}>
            No fue posible entregar el PIN de acceso al correo {userData.email} asociado al usuario {userData.username}. 
            Por favor contáctese con un administrador para cambiarlo.
          </Typography>

        </Paper>
      </Grid>
    </Grid>
  );
}

export default LoginVerificationWithInvalidEmail;
